import { useMutation } from '@tanstack/react-query';
import { ScheduleMemoType } from '#types/schedule';
import { post } from '../libs';

interface Payload {
  /** 메모 내용 */
  memo: string;
  memoType: ScheduleMemoType;
  /** 날짜 - 일간 메모인 경우 사용 (YYYY-MM-DD) */
  date?: string;
  /** 주간 및 월간 메모의 경우 사용 */
  year?: number;
  /** 주간 메모의 경우 사용 (1~53) */
  week?: number;
  /** 월간 메모의 경우 사용 (1~12) */
  month?: number;
}

/**
 * 코치 - 일간/주간/월간 메모 생성
 * @link https://api-dev.fibud.kr/api#/%EA%B3%84%EC%A0%95/AccountsController_createCoachMemo
 * @param param0
 * @returns
 */
export default function usePostCoachMemoMutation() {
  return useMutation((payload: Payload) =>
    post<string, Payload>('/accounts/coach-memo', payload)
  );
}
